export default __webpack_public_path__ + "static/media/cardano.d0f23381.svg";